<template>
  <VCard
    flat
    class="d-flex flex-column justify-center align-center grey lighten-4 fill-height pt-6 pt-lg-9 pb-6 pb-lg-9 px-2" width="100%"
  >
    <span class="subitle-1 text-center mt-4 recording">
      {{ $t('recording') }}
    </span>
  </VCard>
</template>

<script>
export default {
  name: 'CandidateInterviewRecording',
};
</script>

<style scoped>
.recording::after {
  content: '';
  display: inline-block;
  width:  4px;
  height: 4px;
  margin-left: 0px;
  position: relative;
  top: -8px;
  border-radius: 50%;
  background: red;
}
</style>

<i18n locale="en" lang="yaml">
  recording: Recording
</i18n>

<i18n locale="ru" lang="yaml">
  recording: Идёт запись
</i18n>
